'use client';

import type { ReactNode } from 'react';

import { Header } from '@/components/layout/Header';
import { usePathname } from '@/i18n/routing';

interface SiteChromeProps {
  children: ReactNode;
}

/**
 * Marketing Header + top padding for public pages.
 * Auth routes use AuthLayout as the sole chrome (no marketing nav conflict).
 */
export function SiteChrome({ children }: SiteChromeProps) {
  const pathname = usePathname();
  const isAuthRoute = pathname === '/auth' || pathname.startsWith('/auth/');

  if (isAuthRoute) {
    return <>{children}</>;
  }

  return (
    <>
      <Header />
      <div className='pt-16'>{children}</div>
    </>
  );
}
